"use strict";

require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-prototype-of.js");
require("core-js/modules/es.object.set-prototype-of.js");
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.reflect.to-string-tag.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.to-string.js");
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./DashboardLayoutBodyStyle.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function cov_1bihoxun7v() {
  var path = "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_layout/DashboardLayoutBody.tsx";
  var hash = "8fd3f8922d1a4c166c8d5b2c721a1186ee3bded4";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_layout/DashboardLayoutBody.tsx",
    statementMap: {
      "0": {
        start: {
          line: 15,
          column: 81
        },
        end: {
          line: 17,
          column: 3
        }
      },
      "1": {
        start: {
          line: 20,
          column: 57
        },
        end: {
          line: 20,
          column: 67
        }
      },
      "2": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 37,
          column: 6
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 19,
            column: 3
          }
        },
        loc: {
          start: {
            line: 19,
            column: 18
          },
          end: {
            line: 38,
            column: 3
          }
        },
        line: 19
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 26,
            column: 25
          },
          end: {
            line: 26,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 26,
            column: 25
          },
          end: {
            line: 26,
            column: 36
          }
        }, {
          start: {
            line: 26,
            column: 40
          },
          end: {
            line: 26,
            column: 53
          }
        }],
        line: 26
      },
      "1": {
        loc: {
          start: {
            line: 28,
            column: 24
          },
          end: {
            line: 28,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 28,
            column: 24
          },
          end: {
            line: 28,
            column: 35
          }
        }, {
          start: {
            line: 28,
            column: 39
          },
          end: {
            line: 28,
            column: 53
          }
        }],
        line: 28
      },
      "2": {
        loc: {
          start: {
            line: 31,
            column: 11
          },
          end: {
            line: 31,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 31,
            column: 11
          },
          end: {
            line: 31,
            column: 24
          }
        }, {
          start: {
            line: 31,
            column: 28
          },
          end: {
            line: 31,
            column: 43
          }
        }],
        line: 31
      },
      "3": {
        loc: {
          start: {
            line: 33,
            column: 9
          },
          end: {
            line: 35,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 33,
            column: 9
          },
          end: {
            line: 33,
            column: 19
          }
        }, {
          start: {
            line: 34,
            column: 10
          },
          end: {
            line: 34,
            column: 96
          }
        }],
        line: 33
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "8fd3f8922d1a4c166c8d5b2c721a1186ee3bded4"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1bihoxun7v = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1bihoxun7v();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/** @deprecated */
var DashboardLayoutBody = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(DashboardLayoutBody, _React$Component);
  function DashboardLayoutBody() {
    _classCallCheck(this, DashboardLayoutBody);
    return _callSuper(this, DashboardLayoutBody, arguments);
  }
  _createClass(DashboardLayoutBody, [{
    key: "render",
    value: function render() {
      cov_1bihoxun7v().f[0]++;
      var _ref = (cov_1bihoxun7v().s[1]++, this.props),
        fillSideWidth = _ref.fillSideWidth,
        renderContent = _ref.renderContent,
        renderSide = _ref.renderSide;
      cov_1bihoxun7v().s[2]++;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('od-dashboard-layout-body__center', 'col-xs-12', {
          'col-md-12': (cov_1bihoxun7v().b[0][0]++, !renderSide) && (cov_1bihoxun7v().b[0][1]++, fillSideWidth),
          'col-md-8': !!renderSide,
          'col-lg-8': (cov_1bihoxun7v().b[1][0]++, !renderSide) && (cov_1bihoxun7v().b[1][1]++, !fillSideWidth)
        })
      }, (cov_1bihoxun7v().b[2][0]++, renderContent) && (cov_1bihoxun7v().b[2][1]++, renderContent())), (cov_1bihoxun7v().b[3][0]++, renderSide) && (cov_1bihoxun7v().b[3][1]++, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-12 col-md-4 od-dashboard-layout-body-side"
      }, renderSide())));
    }
  }]);
  return DashboardLayoutBody;
}((_react["default"].Component));
_defineProperty(DashboardLayoutBody, "defaultProps", (cov_1bihoxun7v().s[0]++, {
  fillSideWidth: true
}));